/**
 * Single source of truth for app-wide user-facing copy.
 *
 * Anything rendered on every page (or on every agent page) belongs here so a
 * new agent picks the text up automatically instead of hard-coding its own copy.
 */

/** Shown at the bottom of every page via <AiDisclaimer /> in Layout. */
export const AI_DISCLAIMER =
  'OmniLinQ is AI and can make mistakes. Please double-check responses.';
